import { attachVueSentry } from './monitoring/sentry'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
// 全站仅用 ElMessage / ElMessageBox 两个命令式 API（各组件内直接从 element-plus 按需 import），
// 无需 app.use(ElementPlus) 全量注册；代码中无任何 <el-*> 标签，也未使用 Element 图标。
// 故移除「全量组件注册」和「全量图标注册」，仅保留全量 CSS 以保证弹窗/toast 样式正常。
import 'element-plus/dist/index.css'
import App from './App.vue'
import router from './router'
import i18n from './locales'
import './styles/global.scss'

const app = createApp(App)
attachVueSentry(app)

app.use(createPinia())
app.use(router)
app.use(i18n)

app.mount('#app')
